module.exports = __webpack_public_path__ + "static/media/editIcon.3768040a.svg";